"use client";

import React from "react";
import { ClipboardPen, Droplets, Sun } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Request Quote",
  description: "Contact us for a free, no-obligation estimate tailored to your specific solar setup.",
  icon: ClipboardPen
}, {
  title: "Professional Cleaning",
  description: "Our experts use safe, specialized equipment and pure water to remove dirt and debris.",
  icon: Droplets
}, {
  title: "Maximum Solar Performance",
  description: "Enjoy restored efficiency, increased energy output, and lower bills immediately.",
  icon: Sun
}];
export default function ThePathToPeakPerformance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-path-to-peak-performance" className="py-24 md:py-32 bg-background relative overflow-hidden">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes slide-horizontal {
            0% { transform: translateX(-100%); opacity: 0; }
            20% { opacity: 1; }
            80% { opacity: 1; }
            100% { transform: translateX(400%); opacity: 0; }
          }
          @keyframes slide-vertical {
            0% { transform: translateY(-100%); opacity: 0; }
            20% { opacity: 1; }
            80% { opacity: 1; }
            100% { transform: translateY(400%); opacity: 0; }
          }
          .animate-light-h { animation: slide-horizontal 4s ease-in-out infinite; }
          .animate-light-v { animation: slide-vertical 4s ease-in-out infinite; }
        `
    }} />

      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6 tracking-tight">
            The Path to <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-chart-3">Peak Performance</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Our simple, transparent process ensures your solar panels are cleaned safely and effectively, restoring them to maximum efficiency.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          {}
          <div className="hidden md:block absolute top-16 left-[10%] right-[10%] h-[2px] border-t-2 border-dashed border-border z-0">
            {}
            <div className="absolute top-[-3px] left-0 h-[4px] w-1/4 bg-gradient-to-r from-transparent via-primary to-transparent animate-light-h blur-[1px]"></div>
          </div>

          {}
          <div className="md:hidden absolute top-[10%] bottom-[10%] left-1/2 w-[2px] -translate-x-1/2 border-l-2 border-dashed border-border z-0">
            {}
            <div className="absolute top-0 left-[-3px] w-[4px] h-1/4 bg-gradient-to-b from-transparent via-primary to-transparent animate-light-v blur-[1px]"></div>
          </div>

          {}
          <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-16 md:gap-8 relative z-10">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <div key={index} data-index={index} className="flex flex-col items-center text-center flex-1 relative w-full max-w-xs group">
                  {}
                  <span className="absolute top-0 md:top-4 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[8rem] md:text-[10rem] font-black text-muted/30 select-none z-[-1] transition-transform duration-500 group-hover:scale-110">
                    0{index + 1}
                  </span>

                  {}
                  <div className="w-32 h-32 rounded-full bg-gradient-to-br from-primary to-chart-3 text-primary-foreground flex items-center justify-center shadow-[0_8px_32px_rgba(var(--primary),0.3)] mb-8 relative overflow-hidden transition-transform duration-500 group-hover:-translate-y-2">
                    {}
                    <div className="absolute inset-0 bg-white/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    <Icon className="w-12 h-12 relative z-10" strokeWidth={1.5} />
                  </div>

                  {}
                  <div className="bg-background/80 backdrop-blur-sm p-4 rounded-2xl">
                    <h3 className="text-xl font-bold text-foreground mb-3">
                      {step.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}